var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRouterErr = function SvgRouterErr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 4v1.204H4.216c-.73 0-1.377.437-1.662 1.092l-.053.138-1.207 3.602-.036.138c-.024.1-.04.196-.047.29l-.006.138a1.81 1.81 0 0 0 1.66 1.792l.147.006h13.252a1.81 1.81 0 0 0 1.807-1.798c0-.137-.018-.278-.054-.428l-.038-.14-.012-.034h1.246c.025.125.043.248.053.371l.01.231v4.8c0 1.634-1.533 2.912-3.412 2.998l-.203.005H3.614c-1.97 0-3.614-1.31-3.614-3.003v-4.8c0-.232.029-.461.083-.694l.063-.235 1.209-3.614a3.022 3.022 0 0 1 2.676-2.053L4.216 4H11zm7.072 9a3 3 0 0 1-1.631.6l-.176.005H3.012A3 3 0 0 1 1.204 13v2.402c0 .918.963 1.725 2.235 1.793l.175.005h12.047c1.358 0 2.41-.838 2.41-1.798V13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.049.331 1.12 1.12-2.8 2.8 2.8 2.799-1.12 1.119-2.799-2.8-2.798 2.8-1.12-1.12 2.799-2.799-2.799-2.8 1.12-1.119 2.798 2.8z"
  })));
};

export default SvgRouterErr;